import React, { ReactNode, useState } from 'react';
import { FormControlProps } from 'react-bootstrap';
import { EnterKeyHint, InputType, TypographySize } from '~/types';
import { capitalizeFirstLetter } from '~/utils/helpers';
import Input from './Input';

interface Props extends FormControlProps {
    className?: string;
    type?: InputType;
    placeholder?: string;
    label?: string;
    leftIcon?: ReactNode;
    rightIcon?: ReactNode;
    message?: string;
    defaultValue?: string | number;
    name: string;
    required?: boolean;
    pattern?: string;
    min?: number | string;
    max?: number | string;
    minLength?: number;
    maxLength?: number;
    value?: any;
    isTextArea?: boolean;
    innerRef?: any;
    onBlur?: () => void;
    onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
    onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void;
    onClick?: (event: React.MouseEvent<HTMLInputElement>) => void;
    enterKeyHint?: EnterKeyHint;
    autoFocus?: boolean;
    editable?: boolean;
    info?: string;
    labelSize?: TypographySize;
    editableSameStyle?: boolean;
    hideMaxLengthCount?: boolean;
}

const disableAutoCapitalize = ['email', 'password', 'url'];

export default function InputContainer(props: Props): JSX.Element {
    const [isShowPassword, setIsShowPassword] = useState(false);

    const onToggleShowPassword = () => {
        setIsShowPassword(!isShowPassword);
    };

    const onHandleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!disableAutoCapitalize.includes(props.type || '')) {
            e.target.value = capitalizeFirstLetter(e.target.value) || '';
        }

        props.onChange && props.onChange(e);
    };

    return (
        <Input
            {...props}
            isShowPassword={isShowPassword}
            onToggleShowPassword={onToggleShowPassword}
            onChange={onHandleChange}
        />
    );
}
